import React from "react";
import TeamHero from "./TeamHero";
import WellBeing from "./WellBeing";
import OurValues from "./OurValues";
import OurJourney from "./OurJourney";
import LifeAtSeekho from "./LifeAtSeekho";
import Container from "../common/Container";
import PeopleOfSeekho from "./PeopleOfSeekho";
import LifeAtSeekhoVideo from "./LifeAtSeekhoVideo";
import OpenRolesAtSeekho from "./OpenRolesAtSeekho";
import PurpleGradient from "../Icons/TeamAndCulture/LifeAtSeekho/PurpleGradient";
import YellowGradient from "../Icons/TeamAndCulture/LifeAtSeekho/YellowGradient";
import PurpleBottomGradient from "../Icons/TeamAndCulture/LifeAtSeekho/PurpleBottomGradient";
import PurpleTopLeftGradient from "../Icons/TeamAndCulture/LifeAtSeekho/PurpleTopLeftGradient";
import OurFounders from "./OurFounders";
import OurRatingsAndReviews from "./OurRatingsAndReviews";

const TeamAndCulture = () => {
  return (
    <section className="text-white md:-mt-4 lg:-mt-6">
      {/* Team Hero Section */}
      <section className="md:pb-20">
        <div>
          <TeamHero />
        </div>
      </section>

      {/* Our Journey Section */}
      <section className="relative py-16 bg-gradient-to-b from-[#191919]/40 via-[#191919] to-[#191919] border-t border-b border-t-[#4e286b] border-b-[#434343] md:py-14 md:!pb-[90px]">
        <PurpleGradient className="hidden lg:block lg:absolute lg:top-0 lg:w-full" />
        <PurpleTopLeftGradient className="absolute top-0 left-0 lg:hidden" />
        <OurJourney />
        <YellowGradient className="absolute bottom-0 right-0" />
        <PurpleBottomGradient className="hidden lg:block lg:absolute bottom-0 left-0" />
      </section>

      {/* Meet Our Founders Section */}
      <section className="mt-16 lg:!mt-28">
        <Container>
          <OurFounders />
        </Container>
      </section>

      {/* Our Values Section */}
      <section className="py-16 lg:!py-32">
        <Container>
          <OurValues />
        </Container>
      </section>

      {/* Life at Seekho Section */}
      <section className="relative py-16 bg-gradient-to-b from-[#191919]/40 via-[#191919] to-[#191919] border-t border-b border-t-[#4e286b] border-b-[#434343] lg:!py-20">
        <PurpleGradient className="hidden lg:block lg:absolute lg:top-0 lg:w-full" />
        <PurpleTopLeftGradient className="absolute top-0 left-0 lg:hidden" />
        <Container className="relative z-10 !px-0">
          <LifeAtSeekho />
        </Container>
        <YellowGradient className="absolute bottom-0 right-0" />
        <PurpleBottomGradient className="hidden lg:block lg:absolute bottom-0 left-0" />
      </section>

      {/* Life at Seekho Video Section */}
      <Container className="py-16 lg:!py-20">
        <LifeAtSeekhoVideo />
      </Container>

      {/* Well Being Section */}
      <section className="bg-gradient-to-br from-[#2d0d47] via-[#18171a] to-[#2e1564] py-12 border-y border-[#422f50] lg:py-20 lg:bg-gradient-to-br lg:from-[#121212] lg:via-[#231b37]/60 lg:to-[#342f1c]/70 lg:border-[#363636]">
        <Container>
          <WellBeing />
        </Container>
      </section>

      {/* People of Seekho Section */}
      <section className="py-20 lg:py-28 lg:pb-36">
        <PeopleOfSeekho />
      </section>

      {/* Open Roles at Seekho Section */}
      <section className="py-14 relative bg-gradient-to-b from-[#191919]/40 via-[#191919] to-[#2c1758]/40 lg:py-20">
        <PurpleGradient className="hidden lg:block lg:absolute lg:top-0 lg:w-full" />
        <PurpleTopLeftGradient className="absolute top-0 left-0 lg:hidden" />
        <Container className="relative z-10">
          <OpenRolesAtSeekho />
        </Container>
        <YellowGradient className="absolute bottom-0 left-0 -scale-x-100" />
        <PurpleBottomGradient className="hidden lg:block lg:absolute bottom-0 right-0 -scale-x-100" />
      </section>

      <section className="py-14 lg:py-20">
        <Container>
          <OurRatingsAndReviews />
        </Container>
      </section>
    </section>
  );
};

export default TeamAndCulture;
